import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL preservation: the old app's public logged-out reminders landing lived at
// /reminders/add (11k views/90d — linked from the logged-out nav). Since 2026-09-28 the
// landing IS the public /reminders/birthday/add page, so this only redirects.
export const Route = createFileRoute("/reminders_/add")({
  beforeLoad: () => {
    throw redirect({ to: "/reminders/birthday/add", replace: true });
  },
});
